import { useEffect, useState } from "react";
import { Quote as QuoteIcon, Star } from "lucide-react";
import { api } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function TestimonialsSection() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get("/testimonials").then(({ data }) => setItems(data)).catch(() => setItems([]));
    }, []);

    if (items.length === 0) return null;

    return (
        <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12" data-testid="testimonials-section">
            <Reveal>
                <div className="text-center max-w-3xl mx-auto">
                    <span className="overline">Témoignages</span>
                    <h2 className="mt-5 font-serif text-5xl md:text-6xl font-light leading-tight text-brand-ink">
                        Ce qu'en disent
                        <span className="italic"> nos clients</span>.
                    </h2>
                </div>
            </Reveal>

            <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {items.slice(0, 6).map((t, i) => (
                    <Reveal key={t.id} delay={i * 80}>
                        <article
                            className="bg-brand-bgalt border border-brand-border p-8 h-full flex flex-col"
                            data-testid={`testimonial-${t.id}`}
                        >
                            <QuoteIcon size={28} strokeWidth={1.2} className="text-brand-sage" />
                            <p className="mt-5 font-serif italic text-xl leading-relaxed text-brand-ink flex-1">
                                « {t.quote} »
                            </p>
                            <div className="mt-7 pt-5 border-t border-brand-border flex items-center justify-between">
                                <div>
                                    <p className="font-serif text-lg text-brand-ink">{t.author}</p>
                                    <p className="text-xs uppercase tracking-[0.18em] text-brand-sageDark mt-1">
                                        {[t.role, t.location].filter(Boolean).join(" · ")}
                                    </p>
                                </div>
                                <div className="flex gap-0.5">
                                    {Array.from({ length: t.rating }).map((_, idx) => (
                                        <Star key={idx} size={14} strokeWidth={1.5} className="text-brand-sage fill-brand-sage" />
                                    ))}
                                </div>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
